<template>
  <div v-if="hero" class="hero-container">
    <img class="hero-banner" :src="hero.image" :alt="hero.imageAlt" />
    <video
      class="hero-video"
      loop
      autoplay
      muted
      autobuffer
      preload="auto"
      playsinline
    >
      <source
        :src="
          hero && hero.video !== '' && hero.type === 'video/mp4'
            ? hero.video
            : ''
        "
        type="video/mp4"
      />
    </video>
  </div>
</template>

<script>
export default {
  name: 'HeroVideo',
  props: {
    hero: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-container {
  position: relative;

  @media only screen and (min-width: 2560px) {
    margin-bottom: 375px;
  }

  .hero-video {
    width: 100%;
    height: 35rem;
    object-fit: cover;
    position: absolute;
    left: 0;

    @media only screen and (min-width: 2560px) {
      height: 55rem;
    }
  }

  .hero-banner {
    object-fit: cover;
    width: 100%;
    height: 35rem;
    z-index: -1;
  }
}
</style>
